import React from "react";
import "./PlayersSection.css";

const CricketPlayersSection = () => {
  const players = [
    { img: "/Images/teamlogo1.jpeg.jpg", name: "Risor sport", },
    { img: "/Images/teamlogo6.jpeg.jpg", name: "Super Kings", },
    { img: "/Images/teamlogo9.jpeg.jpg", name: "Neeraj Rathour", },
    { img: "/Images/teamlogo4.jpeg.jpg", name: "Guru Nanak college", },
    { img: "/Images/teamlogo2.jpeg.jpg", name: "Fearless Fighters", },
    { img: "/Images/teamlogo8.jpeg.jpg", name: "Queen Of Kolihills", },
    { img: "/Images/teamlogo3.jpeg.jpg", name: "AJVJ", },
    { img: "/Images/teamlogo5.jpeg.jpg", name: "Signature", },
    { img: "/Images/teamlogo7.jpeg.jpg", name: "Believe", },
  ];

  return (
    <section className="cricket-players59-section">
      <div className="cricket-players59-header">
        <img src="/Images/ballimg.png" alt="Ball" className="cricket-players59-ball-icon" />
        <p className="cricket-players59-note">Stars who turn every match into magic!.</p>
        <p className="cricket-players59-title">Our Teams</p>
      </div>

      <div className="cricket-players59-container">
        {players.map((player, index) => (
          <button key={index} className="cricket-players59-item">
            <img src={player.img} alt={player.name} className="cricket-players59-photo" />
            <div className="cricket-players59-info">
              <h3>{player.name}</h3>
              <p>{player.role}</p>
            </div>
          </button>
        ))}
      </div>

      <button className="cricket-players59-view-btn">View All Teams</button>
    </section>
  );
};

export default CricketPlayersSection;
